export const lastNToasts = (n, toasts) => toasts.slice(-n).reverse();
